import {
  GestorDashboardBreakdownList,
  GestorDashboardMetricCard,
  GestorDashboardMonthlyBars,
  formatCurrency,
  formatNumber,
  formatPercent,
} from '@/components/Gestores/GestorDashboardWidgets'
import type { GestorDashboardFinancialMetrics } from '@/components/Gestores/gestorDashboardTypes'

type Props = {
  financial: GestorDashboardFinancialMetrics
}

export function GestorDashboardFinancialView({ financial }: Props) {
  return (
    <div className='space-y-4'>
      <div className='grid gap-3 sm:grid-cols-2 xl:grid-cols-4'>
        <GestorDashboardMetricCard label='Receita captada' value={formatCurrency(financial.revenue)} tone='success' />
        <GestorDashboardMetricCard label='Investimento' value={formatCurrency(financial.spend)} />
        <GestorDashboardMetricCard label='Sessões' value={formatNumber(financial.sessions)} />
        <GestorDashboardMetricCard label='Taxa conversão' value={formatPercent(financial.conversionRate)} />
        <GestorDashboardMetricCard label='Leads' value={formatNumber(financial.leads)} />
        <GestorDashboardMetricCard label='Cliques' value={formatNumber(financial.clicks)} />
      </div>

      <div className='grid gap-3 xl:grid-cols-2'>
        <GestorDashboardMonthlyBars
          title='Histórico receita (meses)'
          rows={financial.revenueByMonth}
          valueKey='effortMinutes'
        />
        <GestorDashboardBreakdownList
          title='Receita por cliente'
          rows={financial.revenueByWorkspace}
          valueFormatter={formatCurrency}
        />
      </div>
    </div>
  )
}
